export default __webpack_public_path__ + "3e34b142a630565a7576eab7fcf0a493.png";